import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from "../../helpers/graphQLShortcuts";
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
// import {filterHeadline, filterHTML} from "../../helpers/filters";
import './VerticalSplitContent.scss';
import Paragraph from "../Paragraph";
import {filterHeadline, filterHTML} from "../../helpers/filters";

class VerticalSplitContentQuery extends Query<{id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphVerticallyCenteredSplitConten {
          fieldImagePosition
          fieldVarMobileDisplayOrder
          fieldVarContainerPadding
          fieldObjectSectionStyle {
              ${fieldObjectSectionStyle}
          }
          fieldImage {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    targetId
                    alt
                    title
                  }
                }
              }
          }
          fieldHeadlineColor
          fieldTxtHeadline
          fieldSubheadlineColor
          fieldTxtSubTitle
          fieldHtmlBody {
            value
            format
            processed
          }
          fieldObjectSplitCta {
            targetRevisionId
          }
        }
      }
    }
  }
}
`;

const VerticalSplitContent = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <VerticalSplitContentQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            let classes = '';

            if (field.fieldVarMobileDisplayOrder) {
                classes += ` verticalSplitContent--${field.fieldVarMobileDisplayOrder}Mobile`
            }
            if (field.fieldImagePosition) {
                classes += ` verticalSplitContent--image-${field.fieldImagePosition}`;
            }
            if (field.fieldVarContainerPadding) {
                classes += ` verticalSplitContent--padding-${field.fieldVarContainerPadding}`;
            }
            if (field.fieldVarAdditionalCss) {
                classes += ` ${field.fieldVarAdditionalCss}`;
            }

            // Generate Styles Object
            const styles = fieldObjectSectionStyleCss(field.fieldObjectSectionStyle, classes.trim());

            const cssId = field && field.fieldObjectSectionStyle && field.fieldObjectSectionStyle.entity && field.fieldObjectSectionStyle.entity.fieldCssId ? field.fieldObjectSectionStyle.entity.fieldCssId : null;

            // Ensure an Image Exists
            if (!(field && field.fieldImage && field.fieldImage.entity && field.fieldImage.entity.fieldMediaImage && field.fieldImage.entity.fieldMediaImage.url)) return null;

            const imagePosition = field && field.fieldImagePosition && field.fieldImagePosition === 'right' ? 'right' : 'left';

            markComponentLoadedAs(id, true);

            const renderImage = () => (
                <div className="verticalSplitContent__column verticalSplitContent__image">
                    <img src={field.fieldImage.entity.fieldMediaImage.url} alt={field.fieldImage.entity.fieldMediaImage.alt}/>
                </div>
            );

            return (
                <section className={`verticalSplitContent${styles.classNames}`} style={styles.css} id={cssId}>

                    {styles.childBackground.isActive && (
                        <div style={styles.childBackground.css}/>
                    )}

                    <div className="container">

                        {imagePosition === 'left' ? renderImage() : null}

                        <div className="verticalSplitContent__column verticalSplitContent__content">

                            {field.fieldTxtHeadline && (
                                // eslint-disable-next-line react/no-danger
                                <h2 style={field.fieldHeadlineColor ? {color: field.fieldHeadlineColor} : null} dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                            )}

                            {field.fieldTxtSubTitle && (
                                // eslint-disable-next-line react/no-danger
                                <h3 style={field.fieldSubheadlineColor ? {color: field.fieldSubheadlineColor} : null} dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtSubTitle)}} />
                            )}

                            {field.fieldHtmlBody && field.fieldHtmlBody.processed && (
                                // eslint-disable-next-line react/no-danger
                                <div className="verticalSplitContent__body">
                                    {filterHTML(field.fieldHtmlBody.processed, true)}
                                </div>
                            )}

                            {field.fieldObjectSplitCta && field.fieldObjectSplitCta.map(component => (
                                <Paragraph key={`${id}_${component.targetRevisionId}`}
                                           id={String(component.targetRevisionId)}
                                           handleLoadedComponents={handleLoadedComponents}/>
                            ))}
                        </div>

                        {imagePosition === 'right' ? renderImage() : null}

                    </div>

                </section>
            );
        }}
    </VerticalSplitContentQuery>
);

VerticalSplitContent.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default VerticalSplitContent;



// WEBPACK FOOTER //
// ./frontend/components/VerticalSplitContent/VerticalSplitContent.jsx